// document.addEventListener('click', function(e) {
//   const deleteBtn = e.target.closest('[cart-remove-button] button');
//   if (!deleteBtn) return;
  
//   const cartItem = deleteBtn.closest('.cart-item');
//   if (!cartItem || cartItem.classList.contains('hidden')) return;
  
//   const dataFreeKey = cartItem.getAttribute('data-free-key');
//   if (!dataFreeKey) return;
  
//   // Find hidden item aur 1 second baad delete karo
//   setTimeout(function() {
//     const hiddenItem = document.querySelector('.cart-item.hidden[data-free-key="' + dataFreeKey + '"]');
//     if (hiddenItem) {
//       const hiddenDeleteBtn = hiddenItem.querySelector('[cart-remove-button] button');
//       if (hiddenDeleteBtn) hiddenDeleteBtn.click();
//     }
//   }, 1000);
// });


// $('button.header__localization-button').on('click', function (e) {
//   e.preventDefault();
// //   alert()
//   $(this).siblings('ul#HeaderCountryList').show();
// })

// Standalone fix for country selector scrollbar issue

// Keyboard navigation for country selector
(function() {
  'use strict';
  
  function initKeyboardNavigation() {
    const button = document.querySelector('.header__localization-button');
    const list = document.getElementById('HeaderCountryList');

    if (!button || !list) {
      console.warn('Keyboard navigation elements not found');
      return;
    }

    const listItems = list.querySelectorAll('.disclosure__item');
    
    if (!listItems.length) {
      console.warn('No disclosure items found');
      return;
    }
    
    console.log('Keyboard navigation initialized with', listItems.length, 'countries');

    let searchTimeout;
    let searchString = '';

    function handleKeyboardSearch(e) {
      if (!list || !listItems.length) return;
      
      // Check if list is visible
      const detailsElement = list.closest('details');
      const isListVisible = detailsElement && detailsElement.hasAttribute('open');
      
      if (!isListVisible) return;
      
      // Check if a letter key was pressed (a-z, A-Z)
      if (e.key.length === 1 && e.key.match(/[a-z]/i)) {
        e.preventDefault();
        e.stopPropagation();
        
        if (searchTimeout) clearTimeout(searchTimeout);
        
        searchString += e.key.toLowerCase();
        console.log('Searching for:', searchString);
        
        // Find matching country
        const matchedItem = Array.from(listItems).find(item => {
          const countrySpan = item?.querySelector('.disclosure__link span');
          if (countrySpan) {
            const countryName = countrySpan.textContent.trim().toLowerCase();
            return countryName.startsWith(searchString);
          }
          return false;
        });
        
        if (matchedItem) {
          console.log('Match found:', matchedItem.textContent.trim());
          
          // Remove previous highlights
          listItems.forEach(item => {
            const link = item?.querySelector('.disclosure__link');
            if (link) {
              link.style.backgroundColor = '';
            }
          });
          
          // Calculate scroll position
          const itemTop = matchedItem.offsetTop;
          const listScrollTop = list.scrollTop;
          const listHeight = list.clientHeight;
          const itemHeight = matchedItem.clientHeight;
          
          // Scroll if item is outside visible area
          if (itemTop < listScrollTop || itemTop + itemHeight > listScrollTop + listHeight) {
            list.scrollTo({
              top: itemTop - 50,
              behavior: 'smooth'
            });
          }
          
          // Highlight the matched item
          const matchedLink = matchedItem.querySelector('.disclosure__link');
          if (matchedLink) {
            matchedLink.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
            matchedLink.focus();
          }
        } else {
          console.log('No match found for:', searchString);
        }
        
        // Reset search string after 1.5 seconds
        searchTimeout = setTimeout(() => {
          console.log('Search reset');
          searchString = '';
          // Remove all highlights
          if (listItems && listItems.length) {
            listItems.forEach(item => {
              const link = item?.querySelector('.disclosure__link');
              if (link) {
                link.style.backgroundColor = '';
              }
            });
          }
        }, 1500);
      }
    }

    // Add keyboard event listeners
    document.addEventListener('keydown', handleKeyboardSearch);
    list.addEventListener('keydown', handleKeyboardSearch);

    // Clear highlights when button is clicked
    if (button) {
      button.addEventListener('click', () => {
        searchString = '';
        if (searchTimeout) clearTimeout(searchTimeout);
        
        if (listItems && listItems.length) {
          listItems.forEach(item => {
            const link = item?.querySelector('.disclosure__link');
            if (link) {
              link.style.backgroundColor = '';
            }
          });
        }
      });
    }
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKeyboardNavigation);
  } else {
    initKeyboardNavigation();
  }
  
})();

$('button.header__localization-button').on('click', function (e) {
    const list = document.getElementById('HeaderCountryList');
    const listItems = list.querySelectorAll('.disclosure__item');
    listItems[0].focus()
})

function initUpsellSwiper() {
  // Destroy existing instance if it exists
  if (window.upsellSwiper && window.upsellSwiper.destroy) {
    window.upsellSwiper.destroy(true, true);
  }

  window.upsellSwiper = new Swiper(".upsell-products-list", {
    slidesPerView: "auto",
    autoHeight: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.custom-next',
      prevEl: '.custom-prev',
    }
  });
}

// Initial init
initUpsellSwiper();

// For Shopify section re-renders
document.addEventListener('shopify:section:load', function () {
  initUpsellSwiper();
});

// For MutationObserver (watches for DOM changes)
const observer = new MutationObserver(function () {
  initUpsellSwiper();
});

const target = document.querySelector('#CartDrawer');
if (target) {
  observer.observe(target, { childList: true, subtree: true });
}

window.addEventListener('pageshow', function(event) {
    if (event.persisted || (window.performance && window.performance.getEntriesByType('navigation')[0]?.type === 'back_forward')) {
        // Page was restored from bfcache - refresh cart UI
        refreshCartUI();
    }
});

async function refreshCartUI() {
  try {
      // Fetch fresh cart data
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Update cart count bubble
      const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
      cartCountBubbles.forEach(bubble => {
      const countElement = bubble.querySelector('span[aria-hidden="true"]');
      if (countElement) {
          countElement.textContent = cart.item_count;
      }
      bubble.style.display = cart.item_count > 0 ? '' : 'none';
      });

      // Update cart drawer using Section Rendering API
      const sectionsResponse = await fetch(`${window.routes?.cart_url || '/cart'}?sections=cart-drawer,cart-icon-bubble`);
      const sections = await sectionsResponse.json();

      // Update cart drawer
      if (sections['cart-drawer']) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
          const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const newCartDrawer = html.querySelector('cart-drawer');
          if (newCartDrawer) {
          cartDrawer.innerHTML = newCartDrawer.innerHTML;
          // Update empty state class
          if (cart.item_count === 0) {
              cartDrawer.classList.add('is-empty');
          } else {
              cartDrawer.classList.remove('is-empty');
          }
          }
      }
      }

      // Update cart icon bubble
      if (sections['cart-icon-bubble']) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
          const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const newBubble = html.getElementById('cart-icon-bubble');
          if (newBubble) {
          cartIconBubble.innerHTML = newBubble.innerHTML;
          }
      }
      }

      console.log('Cart UI refreshed after navigation');
  } catch (error) {
      console.error('Error refreshing cart:', error);
  }
}